export const relationItemToOption = (item:any) => ({label: item.name, value: item.id});
export const relationItemsToOption = (items:any) => items.map((i:any)=>relationItemToOption(i));
export const recipientItemsToOption = (items:any) => (items.map( (item : any) =>({label: item.name, value: item.idReminderRoleGroupUser})) );
